"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
var react_1 = __importDefault(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var Checkbox = function (_a) {
    var label = _a.label, state = _a.state, setState = _a.setState;
    var handleCheckboxChange = function (e) {
        setState(e.target.checked);
    };
    return (react_1.default.createElement(react_bootstrap_1.Form.Group, null,
        react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "checkbox", label: label, checked: state, onChange: handleCheckboxChange })));
};
exports.Checkbox = Checkbox;
